document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('#selling-plan-select, #sub-drawer-plan-select').forEach(function(select) {
    const card = select.closest('[data-option="subscribe"]');
    if (!card) return;
    const terms = card.querySelector('.moby-trial-offer__terms');
    const price = card.querySelector('.moby-buy-box__option-price, .moby-sub-drawer__price-current');
    const billing = card.querySelector('.moby-buy-box__billed-note, .moby-sub-drawer__billed-note');
    const benefit = card.querySelector('[data-delivery-frequency-text], [data-monthly-freq-text]');
    const giftTiming = card.querySelector('.moby-gift-journey__timing');
    const defaults = new Map([terms, price, billing, benefit].filter(Boolean).map(node => [node, node.innerHTML]));
    select.addEventListener('change', function() {
      const option = select.options[select.selectedIndex];
      if (!option) return;
      if (giftTiming) giftTiming.hidden = !!option.dataset.renewalText;
      defaults.forEach((html, node) => { node.innerHTML = html; });
      if (benefit && option.dataset.freqLabel) benefit.textContent = option.dataset.freqLabel;
      if (terms && option.dataset.renewalText) terms.textContent = option.dataset.renewalText;
      if (price && option.dataset.recurringLabel) price.textContent = option.dataset.recurringLabel;
      if (billing && option.dataset.billingText) {
        const firstDelivery = billing.querySelector('.moby-first-delivery-price');
        billing.replaceChildren(...(firstDelivery ? [firstDelivery, document.createElement('br')] : []), document.createTextNode(option.dataset.billingText));
      }
    });
  });
});
